import React from 'react';

// assets
import { General } from 'icons/untitledui';

// styles
import * as Styled from 'documentDisplay/styles/Document.style';
import * as Text from 'theme/components/Text.style';

interface DocumentProps {
  document?: {
    language?: string;
    parent?: {
      id?: string;
      use_source_url?: boolean;
    };
    title?: string;
    url?: string;
  };
}

export default function WarningDocument({
  document,
}: DocumentProps): JSX.Element {
  return (
    <Styled.StyledLink href={document?.url} download={document?.title}>
      <General.Download01 size={15} />
      <Text.P2Semibold>{document?.title}</Text.P2Semibold>
    </Styled.StyledLink>
  );
}
